// extracted by mini-css-extract-plugin
export default {"button":"ListAddedAndDeleted_button__zNpoY"};